export default "__VITE_ASSET__f6206167__"